import React from 'react';

import AboutIntro from '../components/AboutIntro/AboutIntro';
import EmpowerSection from '../components/EmpowerSection/EmpowerSection';
import ConsultingInquiry from '../components/ConsultingInquiry/ConsultingInquiry';

const AboutPage = () => {
  return (
    <>
     
      <AboutIntro />
      <EmpowerSection />
      <ConsultingInquiry />
    </>
  );
};

export default AboutPage;
